import React from 'react';
import styled from 'styled-components';

import Stack from '@mui/material/Stack';
import ButtonBase from '@mui/material/ButtonBase';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { LinkToTracklog } from 'ff/debrief/router';
import { useCurrentTracklog, useDebriefApp } from 'ff/debrief/hooks';
import { durationSecondsToString, formatGroundSpeed } from 'ff/debrief/utils';
import SidebarPanel from 'ff/debrief/layouts/SidebarPanel';
import FlightInfo from 'ff/debrief/components/segments/FlightInfo';
import InfoDivider from 'ff/debrief/components/infoTable/InfoDivider';
import InfoRow from 'ff/debrief/components/infoTable/InfoRow';
import NotesRow from 'ff/debrief/components/infoTable/NotesRow';

interface Props {}

const InfoSidebar: React.FC<Props> = props => {
    const { isShareApp } = useDebriefApp();
    const { tracklog, trimmedValues, metadata } = useCurrentTracklog();

    if (!tracklog || !trimmedValues) return null;
    return (
        <SidebarPanel>
            <Stack py={2} px={0.5} height="100%">
                <FlightInfo
                    {...tracklog}
                    action={
                        !isShareApp && (
                            <ButtonBase
                                component={LinkToTracklog}
                                sx={{ padding: 1 }}
                            >
                                <ArrowBackIosIcon />
                            </ButtonBase>
                        )
                    }
                />
                <List>
                    <InfoDivider label="Summary" />
                    <InfoRow label="Track Log Name" border>
                        {tracklog.name}
                    </InfoRow>
                    <InfoRow label="Pilot Name" border>
                        {tracklog.pilotName}
                    </InfoRow>
                    <InfoRow label="Initial GPS Source" border>
                        {tracklog.initialGpsSource}
                    </InfoRow>
                    <InfoRow label="Recorded On">
                        {tracklog.recordingDevice}
                    </InfoRow>
                    <InfoDivider label="Metrics" />
                    <InfoRow label="Flight Time" border>
                        {durationSecondsToString(
                            trimmedValues.actualFlightTime
                        )}
                    </InfoRow>
                    <InfoRow label="Avg Ground Speed" border>
                        {formatGroundSpeed(trimmedValues?.avgGndspd)}
                    </InfoRow>
                    <InfoRow
                        label="Minimum g Load"
                        showSentryMsg={!trimmedValues?.minimumG}
                        border
                    >
                        {trimmedValues?.minimumG
                            ? trimmedValues?.minimumG.toFixed(2)
                            : '-'}
                    </InfoRow>
                    <InfoRow
                        label="Maximum g Load"
                        showSentryMsg={!trimmedValues?.maximumG}
                    >
                        {trimmedValues?.maximumG
                            ? trimmedValues?.maximumG.toFixed(2)
                            : '-'}
                    </InfoRow>
                    <InfoDivider label="Notes" />
                    <NotesRow>{metadata?.userRemarks?.trim() || '-'}</NotesRow>
                </List>
            </Stack>
        </SidebarPanel>
    );
};

const List = styled.ol`
    list-style: none;
    margin: 0;
    padding: 0;
`;

export default InfoSidebar;
